

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import axiosJsonpPro from 'axios-jsonp-pro';

import LabelComponent from '@/components/FormElements/LabelComponent.vue';
import SelectComponent from '@/components/FormElements/SelectComponent.vue';
import TicketCheckoutCatalogItem from './TicketCheckoutCatalogItem.vue';
import ApiUtils from '@/api/util/ApiUtils';
import TypeUtils from '@/api/util/TypeUtils';
import TicketDefinitionDTO from '@/api/dto/TicketDefinitionDTO';
import EventDTO from '@/api/dto/EventDTO';
import moment from 'moment';
import AddressUtils from '@/api/util/AddressUtils';
import PaymentFailedModalComponent from '@/components/Events/Tickets/PaymentFailedModalComponent.vue';
import PaymentTimeoutModalComponent from '@/components/Events/Tickets/PaymentTimeoutModalComponent.vue';
import PaymentSuccessfulModalComponent from '@/components/Events/Tickets/PaymentSuccessfulModalComponent.vue';
import CountdownComponent from '@/components/Widgets/CountdownComponent.vue';
import SurveyQuestion from '@/components/Events/SurveyQuestion.vue';
import TicketCheckoutOrderSummary from '@/components/TicketCheckoutOrderSummary.vue';
import BaseVue from '@/api/core/BaseVue';
import {
  OrderFragment,
  OrderFragment_ticketDefinitions,
} from '@/api/gql/gql-types/OrderFragment';
import { IPromiseData, queryPromise } from '@/util/promise';
import { ClientMessageType } from '../../gql-types/globalTypes';
import { ApplyPromoCode_order_applyPromoCode_messages } from '@/api/gql/gql-types/ApplyPromoCode';
import * as EventConstants from '@/api/EventConstants';
import EventDate from '@/components/EventDate.vue';
import TicketCheckoutHeaderOne from '@/components/TicketCheckoutHeaderOne.vue';
import TicketCheckoutHeaderTwo from '@/components/TicketCheckoutHeaderTwo.vue';
import VueAnalytics from 'vue-analytics';
import iDonateSdk from '@/plugins/sdk';
import { CreatePaymentMethodRequest, tokenize } from '@idonatedev/idonate-sdk';
import { createEventsTokenizer, buildPaymentData } from '@/services/tokenizerService';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import PhoneNumber from 'awesome-phonenumber';


@Component({
  components: {
    TicketCheckoutOrderSummary,
    SurveyQuestion,
    LabelComponent,
    SelectComponent,
    TicketCheckoutCatalogItem,
    PaymentFailedModalComponent,
    PaymentTimeoutModalComponent,
    PaymentSuccessfulModalComponent,
    CountdownComponent,
    EventDate,
    TicketCheckoutHeaderOne,
    TicketCheckoutHeaderTwo,
    VuePhoneNumberInput,
  },
})
export default class TicketCheckout extends BaseVue {

  public get disableGetTickets() {
    return this.orderTotal > 0 && !this.tokenizerReady;
  }

  private get ticketsDefinitionsById(): any {
    return this.ticketCatalog.reduce((catalogMap: any, ticketDefinition) => {
      catalogMap[ticketDefinition.id] = ticketDefinition;

      return catalogMap;
    }, {});
  }

  private get salutationOptions() {
    return this.event.guestDetailsSettings.salutationOptions || EventConstants.SALUTATION_OPTIONS;
  }

  private get isCleanTicket(): boolean {
    // want to let a ticket purchaser select a different ticket if they
    // haven't keyed any ticket details yet
    const ticket_attendee = this.selectedClaim.attendee;
    let isClean: boolean = true;
    Object.keys(ticket_attendee).forEach(function(key, idx) {
      // country is always pre-populated, __typename is __typename
      if (key != 'country' && key != '__typename') {
        isClean = isClean && !ticket_attendee[key];
      }
    });
    return isClean;
  }

  get purchaserEmail() {
    return TypeUtils.toStringPath(this.order, 'purchaser.email');
  }

  get orderTotal() {
    return (
      Number(this.order.totalAmount || 0) +
      Number(this.order.donationAmount || 0)
    );
  }

  get calculatedOrderSummary(): any {
    return {
      donationAmount: this.order.donationAmount,
      lineItems: Object.entries(this.ticketsWanted)
        .filter(([definitionId, wanted]) => wanted)
        .map(([definitionId, wanted]) => {
          const ticket = this.ticketsDefinitionsById[definitionId];

          // use promo codes out from cart, if available
          let promo;

          if (this.order && this.order.promoCodes) {
            promo = this.order.promoCodes.find(
              (p) => p.ticketDefinition.id == definitionId,
            );
          }

          return {
            sortIndex: ticket.sortIndex,
            eventDate: moment(this.event.eventStart).format('lll'),
            ticketsCount: wanted,
            ticketName: ticket.name,
            ticketId: ticket.id,
            totalPromoPrice:
              ticket.promoPrice !== null ? ticket.promoPrice * wanted : null,
            totalPrice: (ticket.price || 0) * wanted,
            promoText: promo ? promo.code : null,
          };
        }),
    };
  }

  get orderSummary(): any {
    // group by ticket definition and final/promo price - partially applied promo codes will generate two lineitems
    const lineItemsMap = this.order.claims.reduce((map, claim) => {
      const ticket = this.ticketsDefinitionsById[claim.ticketDefinition.id];
      const key = `${ticket.id}:${
        claim.promoCode ? claim.promoCode.id : 'null'
      }`;

      if (map[key] === undefined) {
        let promoText;

        // ticket will have promoPrice if applicable promo is in cart
        if (ticket.promoPrice !== null) {
          // but claim may not have had promo applied for various reasons
          if (claim.promoCode) {
            promoText = claim.promoCode.code;
          } else {
            promoText = 'Promo unavailable';
          }
        }

        map[key] = {
          sortIndex: ticket.sortIndex,
          eventDate: moment(this.event.eventStart).format('lll'),
          ticketsCount: 0,
          ticketName: ticket.name,
          ticketId: ticket.id,
          totalPromoPrice: null,
          totalPrice: 0,
          promoText,
        };
      }

      const rec = map[key];

      rec.ticketsCount += 1;
      rec.totalPrice += ticket.price || 0;

      if (claim.promoCode && ticket.promoPrice !== null) {
        rec.totalPromoPrice = (rec.totalPromoPrice || 0) + ticket.promoPrice;
      }

      return map;
    }, {});

    const lineItems = Object.values(lineItemsMap);

    return {
      donationAmount: this.order.donationAmount,
      lineItems,
    };
  }

  get sortedTicketClaims(): any[] {
    // there's an expectation to match the order of the order summary
    return Object.values(this.claimsById).sort(
      (a: any, b: any) =>
        a.ticketDefinition.sortIndex - b.ticketDefinition.sortIndex,
    );
  }

  get pageTitle() {
    if (this.orderTotal > 0) {
      return 'Billing Details';
    }
    return 'Order Contact Information';
  }

  private get countries() {
    return AddressUtils.getCountries();
  }

  get selectedClaim() {
    if (this.selectedClaimId) {
      return this.claimsById[this.selectedClaimId];
    }
  }

  get nextClaimIndex() {
    if (!this.selectedClaimId) {
      return 0;
    }

    const rv = this.sortedTicketClaims.findIndex(
      (claim: any) => claim.id === this.selectedClaimId,
    );

    if (rv === -1) {
      console.error('nextClaimIndex invalid');
      return this.sortedTicketClaims.length;
    }

    return 1 + rv;
  }

  get nextClaim() {
    return this.sortedTicketClaims[this.nextClaimIndex];
  }

  set selectedClaim(newValue) {
    if (newValue === null) {
      this.selectedClaimId = null;
    } else {
      this.selectedClaimId = newValue.id;
    }
  }
  @Prop(Boolean) public readonly isPublicApp!: boolean;

  private ticketCatalog: any = [];
  private order: OrderFragment | any = {};

  private promoCode: string = '';
  private applyPromoCodeStatus: IPromiseData | null = null;

  private tokenizer: tokenize.Tokenizer | null = null;
  private tokenizerReady: boolean = false;
  private tokenizerError: string = '';
  private readonly tokenizerContainerId: string = 'payment-tokenizer-container';

  private ticketsWanted: { [key: string]: number } = {};

  private step = 0;
  private claimsById: any = {};
  private selectedClaimId: string | null = null;
  private claimValidationById: any = {};
  private orderExpires: Date | null = null;
  private orderExpiresWatch: number | null = null;
  private preview: boolean = false;
  private event: any = {};
  private eventId = '';
  private ticketEmbedSettings: any = {};
  private isEventInactive: boolean = false;
  private purchaseErrors: string[] = [];

  // this'd be much cleaner if this were using vue-apollo (this.$apollo.mutations.updateAllClaims.loading)
  private copyCurrentClaimToAll_loading: boolean = false;
  private copyCurrentClaimToAll_text: string | null = null;

  public closeForm() {
    this.resetModal();
    if (this.isPublicApp) {
      this.closeModal();
    } else {
      this.refreshPage();
    }
  }

  public refreshCachedOrder(order: OrderFragment) {
    if (order.ticketDefinitions !== null) {
      // typescript: assume that ticketDefinitions never _contains_ nulls
      this.ticketCatalog = TicketDefinitionDTO.fromModel(
        order.ticketDefinitions as OrderFragment_ticketDefinitions[],
      );
    }

    this.order = {
      ...order,
      purchaser: order.purchaser || {
        address: {
          country: 'US',
        },
      },
      donationAmount: this.order.donationAmount,
    };
  }

  public surveyForClaim(claim) {
    return (
      this.ticketsDefinitionsById[claim.ticketDefinition.id].survey || null
    );
  }

  public surveyResponseIndex(claim, question) {
    let index = claim.surveyResponses.findIndex(
      (el) => el.questionId === question.id,
    );

    if (index === -1) {
      index = claim.surveyResponses.length;

      claim.surveyResponses.push({
        questionId: question.id,
        response: 'null',
      });
    }

    return index;
  }

  public applyPromoCode() {
    let promise;

    if (!this.promoCode) {
      promise = Promise.reject('Please enter a Promo Code.');
    } else {
      const promoCode = this.promoCode;

      promise = this.resolveOrder().then((order) => {
        return this.api!.applyPromoCode(order.id, promoCode).then((result) => {
          // refresh from returned data regardless of error - server knows best
          this.refreshCachedOrder(result.data.order.applyPromoCode.order);

          // handle any messages returned that were intended for the user
          const messages = result.data.order.applyPromoCode.messages;

          if (messages) {
            messages.forEach((message) => {
              switch (message.type) {
                case ClientMessageType.ERROR:
                case ClientMessageType.WARNING:
                  this.$msgbox(message.content, message.subject);
                  break;
                default:
                  break;
              }
            });
          }

          if (result.data.order.applyPromoCode.errors) {
            return Promise.reject(
              result.data.order.applyPromoCode.errors.join('\n'),
            );
          }

          this.promoCode = '';

          // nothing else to update - reactive systems will take care of the rest
          return `Promo Code '${promoCode}' applied.`;
        });
      });
    }

    this.applyPromoCodeStatus = queryPromise(promise);
  }

  public releaseAllClaims() {
    const claimIdsToRelease = this.sortedTicketClaims.map(
      (claim: any) => claim.id,
    );

    if (claimIdsToRelease.length === 0) {
      return Promise.resolve([]);
    }

    return this.api!.releaseClaims(this.order.id, claimIdsToRelease).then(
      (result) => {
        return result.data.order.releaseClaims.order.claims;
      },
    );
  }

  private created() {
    this.busy = false;
    if (this.api === null) {
      return;
    }
    const queryParams = this.$route.query;
    const isPreview = queryParams.preview === '1';
    this.api.getEvent(this.$route.params.eventSlug, isPreview).then((res) => {
      const eventUpdate = this.handleSuccessIgnoreError(res, 'data.event');
      this.event = EventDTO.toPreview(
        eventUpdate,
        eventUpdate.ticketDefinitions,
      );
      this.isEventInactive = EventDTO.isEventInactive(eventUpdate);
      this.eventId = this.event.id;
      this.ticketEmbedSettings = EventDTO.toTicketEmbedSettings(
        this.event.ticketEmbedSettings,
        queryParams,
      );
      // use Event's ticket list only for initial load - will be replaced with a refined list when the Order begins
      this.ticketCatalog = TicketDefinitionDTO.fromModel(this.event.actual
        .ticketDefinitions as OrderFragment_ticketDefinitions[]);

      // instentiate the sdk
      Vue.use(iDonateSdk, {
        id: this.event.organization.id,
        sdkConfig: this.$store.getters.sdkConfig,
        recaptchaKey: this.$store.getters.recaptchaKey,
      });

      // Ignore pageviews when:
      //   checkout modal is viewed inside public app
      //   widget is previewed in gms
      if (
        this.event.googleAnalyticsKey &&
        !this.isPublicApp &&
        _.isEmpty(queryParams)
      ) {
        Vue.use(VueAnalytics, {
          id: this.event.googleAnalyticsKey,
          fields: {
            cookieFlags: 'SameSite=None; Secure',
          },
        });
        this.$ga.page({
          page: this.$route.params.eventSlug + '/widget',
          title: this.event.name,
          location: window.location.href,
        });
      }
    });
  }

  private updateValidatingPhoneNumber(event) {
    this.$validator.extend('phone_number', {
      getMessage: (field) => `${field} is not a valid phone number`,
      validate(value) {
        return new Promise((resolve) => {
          const phone = new PhoneNumber(value, event.countryCode);
          resolve({ valid: phone.isValid() });
        });
      },
    });
  }

  // returns the in-progress order or starts and returns a new empty order
  private resolveOrder(): Promise<OrderFragment> {
    if (this.api === null) {
      return Promise.reject('API not initialized...');
    }

    // only begin a new order if one is not already in progress.
    if (this.order === null || this.order.id !== undefined) {
      return Promise.resolve(this.order);
    }

    // Must use this.event.id. Cannot use this.$route.params.eventId (which may be a slug!)
    const isPreview = this.$route.query.preview === '1';
    return this.api.beginOrder(this.event.id, isPreview).then((res) => {
      const order = this.handleSuccessIgnoreError(res, 'data.beginOrder.order');
      this.refreshCachedOrder(order);

      this.orderExpires = new Date(this.order.expires);

      if (this.orderExpiresWatch !== null) {
        // should never hit this path but just in case...
        window.clearInterval(this.orderExpiresWatch);
      }

      this.orderExpiresWatch = window.setInterval(this.checkOrderExpires, 1000);
      this.checkOrderExpires();

      return order;
    });
  }

  private destroyed() {
    if (this.orderExpiresWatch !== null) {
      window.clearInterval(this.orderExpiresWatch);
      this.orderExpiresWatch = null;
    }
  }

  private checkOrderExpires() {
    if (this.orderExpires === null) {
      window.clearInterval(this.orderExpiresWatch!);
      this.orderExpiresWatch = null;
    } else {
      if (new Date() > this.orderExpires) {
        this.closeForm();
        // the styled modal depends on the events modal being shown.....
        // this.$bvModal.show('payment-timeout-modal');
        this.$msgbox(
          'You have surpassed the checkout time limit and your order has expired.',
        );
      }
    }
  }

  private resetModal() {
    this.order = {};
    this.promoCode = '';
    this.destroyTokenizer();
    this.ticketsWanted = {};
    this.step = 0;

    this.claimsById = {};
    this.selectedClaimId = null;
    this.claimValidationById = {};
  }

  private statesFor(country) {
    return AddressUtils.getRegions(country || 'US');
  }

  // update remote order to reflect ticket selection from page 1
  // will begin an order if required
  private prepareTicketClaims(): Promise<any> {
    return this.$validator.validateAll().then((validations) => {
      if (!validations) {
        return Promise.reject('Validation failed');
      }

      const claimsToDelete: string[] = [];
      const definitionIdsInCart: any = {};
      const messageRegistry: any = {}; // use an object to dedupe messages - todo: look into Map

      // this promise nesting is getting a little gross
      return this.resolveOrder().then((order) => {
        // use the calculated order to build up a list of promises for each ticket type to adjust the real order
        const claimPromises = Object.entries(this.ticketsWanted).map(
          ([ticketId, wanted]) => {
            const existingClaims = this.sortedTicketClaims.filter(
              (claim: any) => claim.ticketDefinition.id === ticketId,
            );
            definitionIdsInCart[ticketId] = true;

            const claimCountDelta = wanted - existingClaims.length;

            if (claimCountDelta > 0) {
              // claim delta more tickets
              return this.api!.claimTickets(
                this.order.id,
                ticketId,
                claimCountDelta,
              ).then((result) => {
                const errors = ApiUtils.getValue(
                  result,
                  'data.order.claimTickets.errors',
                );

                // handle any messages returned that were intended for the user
                const claimMessages = ApiUtils.getValue(
                  result,
                  'data.order.claimTickets.messages',
                );

                if (claimMessages) {
                  claimMessages.forEach((message) => {
                    messageRegistry[message.content] = message;
                  });
                }

                if (errors && errors.length > 0) {
                  return Promise.reject(errors.join('\n'));
                }

                this.refreshCachedOrder(result.data.order.claimTickets.order);
                // return updated claims
                return result.data.order.claimTickets.order.claims;
              });
            } else if (claimCountDelta < 0) {
              // build up list of claims to release
              existingClaims.slice(claimCountDelta).forEach((claim: any) => {
                claimsToDelete.push(claim.id);
              });

              // should pipe these IDs down the chain but it's easier to use `claimsToDelete` for now. TODO.
              return Promise.resolve();
            } else {
              // do nothing if count is the same.

              return Promise.resolve();
            }
          },
        );

        // special handling for ticket counts that were reduced to 0/removed from cart
        this.sortedTicketClaims.forEach((claim: any) => {
          if (
            definitionIdsInCart[claim.ticketDefinition.id] === undefined &&
            claimsToDelete.indexOf(claim.id) === -1
          ) {
            claimsToDelete.push(claim.id);
          }
        });

        // add a releaseClaims promise to the stack if needed
        if (claimsToDelete.length > 0) {
          claimPromises.push(
            this.api!.releaseClaims(this.order.id, claimsToDelete).then(
              (result) => {
                this.refreshCachedOrder(result.data.order.releaseClaims.order);
                return result.data.order.releaseClaims.order.claims;
              },
            ),
          );
        }

        return Promise.all(claimPromises)
          .then((claimResults) => {
            // display accumulated/deduplicated messages from claim calls
            Object.values(messageRegistry).forEach((message: any) => {
              switch (message.type) {
                case ClientMessageType.ERROR:
                case ClientMessageType.WARNING:
                  this.$msgbox(message.content, message.subject);
                  break;
                default:
                  break;
              }
            });

            // parse all results and build up remaining claims.
            claimResults.forEach((result) => {
              if (result === undefined) {
                // ignore no-ops
                return;
              }

              (result as any[]).forEach((claim) => {
                this.refreshCachedClaim(claim);
              });
            });

            if (claimsToDelete.length > 0) {
              claimsToDelete.forEach((claimId) => {
                Vue.delete(this.claimsById, claimId);
              });
            }
          })
          .catch((err) => {
            if (err.message !== undefined) {
              err = err.message;
            }
            this.$msgbox(err.toString(), 'Unable to Claim Tickets');
          });
      });
    });
  }

  private refreshCachedClaim(claim) {
    // maybe cleaner to set this in the backend
    if (this.event.guestDetailsSettings.country) {
      claim.attendee.country = claim.attendee.country || 'US';
    }
    Vue.set(this.claimsById, claim.id, claim);
  }

  private showClaim(claim) {
    this.selectedClaim = claim;
  }

  private keypressNumberFilter(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  private moveToClaimConfiguration() {
    this.prepareTicketClaims().then((result) => {
      this.step = 1;
      this.showClaim(this.sortedTicketClaims[0]);
      this.scrollToTop();
    });
  }

  private destroyTokenizer() {
    if (this.tokenizer) {
      try { this.tokenizer.destroy(); } catch (e) { /* ignore cleanup errors */ }
      this.tokenizer = null;
      this.tokenizerReady = false;
      this.tokenizerError = '';
    }
  }

  // Derive a user-facing message for the first field iToke has examined
  // (isEmpty:false) and rejected (isValid:false). isEmpty:true means the
  // iframe has not yet fired an event for that field, so we don't surface
  // an error based on initial state. Drives the Google Wallet case where
  // CVV gets autofilled with masked stars.
  private describeInvalidField(state: tokenize.ValidationState): string {
    if (!state) return '';
    if (state.cvv && !state.cvv.isValid && !state.cvv.isEmpty) {
      return 'Please enter your CVV';
    }
    if (state.cardNumber && !state.cardNumber.isValid && !state.cardNumber.isEmpty) {
      return 'Please check your card number';
    }
    if (state.expiry && !state.expiry.isValid && !state.expiry.isEmpty) {
      return 'Please check the expiration date';
    }
    return '';
  }

  private async initTokenizer() {
    this.destroyTokenizer();

    if (!this.$sdkClient || !this.event.organization.gateway || !this.event.organization.gateway.id) {
      this.tokenizerError = 'Payment gateway is not configured for this event.';
      return;
    }

    await this.$nextTick();

    try {
      this.tokenizer = await createEventsTokenizer(
        this.$sdkClient,
        this.tokenizerContainerId,
        this.event.organization.gateway,
      );

      this.tokenizer.on('ready', () => {
        this.tokenizerReady = true;
        this.tokenizerError = '';
      });

      this.tokenizer.on('validation', (state: tokenize.ValidationState) => {
        if (state.isValid) {
          this.tokenizerError = '';
          return;
        }
        const message = this.describeInvalidField(state);
        if (message) {
          this.tokenizerError = message;
        }
      });

      this.tokenizer.on('error', (err: { message: string }) => {
        this.tokenizerReady = false;
        this.tokenizerError = err.message || 'Payment form error';
      });
    } catch (err) {
      this.tokenizerError = err instanceof Error
        ? err.message
        : 'Failed to load payment form';
    }
  }

  private beforeDestroy() {
    this.destroyTokenizer();
  }

  private moveToBillingDetails() {
    this.$validator
      .validateAll([{ scope: 'attendee' }, { scope: 'survey' }])
      .then((isValid) => {
        if (!isValid) {
          return;
        }

        this.updateCurrentClaim()
          .then(() => {
            this.setClaimValidation(this.selectedClaim, true);

            // do not allow moving to billing unless all claims are marked complete
            if (!this.checkClaimsUpTo(this.selectedClaim)) {
              return;
            }

            this.step++;

            if (this.orderTotal > 0) {
              this.initTokenizer();
            }

            // reselect first claim in case user comes back to the tickets page
            this.selectedClaim = this.sortedTicketClaims[0] as any;
          })
          .catch((err) => {
            this.$msgbox(err, 'Error while configuring Ticket Claim');
          });
        this.scrollToTop();
      });
  }

  private copyCurrentClaimToAll() {
    this.$validator
      .validateAll(
        // only attendee form is validated when copying - survey data is not copied
        'attendee',
      )
      .then((isValid) => {
        if (!isValid) {
          this.$msgbox(
            'Guest Details have not been copied. You may resolve the errors on this page and try again.',
            'Guest Details Incomplete',
          );
          return;
        }
        this.copyCurrentClaimToAll_loading = true;
        this.copyCurrentClaimToAll_text = 'Working...';

        // retain current survey input - user has not submitted it yet
        const currentSurveyResponses = this.selectedClaim.surveyResponses.slice();

        this.updateAllClaims(this.selectedClaim).then(() => {
          this.copyCurrentClaimToAll_loading = false;
          this.copyCurrentClaimToAll_text = 'Details Copied (Copy Again)';

          this.selectedClaim.surveyResponses = currentSurveyResponses;
        });
      });
  }

  private moveToTicket(claimId, forceValidation: boolean = false) {
    const targetClaim: any = claimId
      ? this.claimsById[claimId]
      : this.nextClaim;

    if (this.isCleanTicket && !forceValidation) {
      // allow for switching if the ticket attendee details
      // haven't been modified yet.
      this.selectedClaim = targetClaim;
      this.scrollToTop();
      return;
    }
    this.$validator
      .validateAll([{ scope: 'attendee' }, { scope: 'survey' }])
      .then((isValid) => {
        if (!isValid) {
          return;
        }

        this.updateCurrentClaim().then((result) => {
          this.setClaimValidation(this.selectedClaim, true);

          // reset Copy button text
          this.copyCurrentClaimToAll_text = null;
          this.selectedClaim = targetClaim;
          this.scrollToTop();
        });
      });
  }

  /**
   * Validate all claims up to, but not including, targetClaim. Mark invalid claims.
   */
  private checkClaimsUpTo(targetClaim) {
    let allValid = true;

    for (const claim of this.sortedTicketClaims) {
      if (claim.id === targetClaim.id) {
        // do not validate claim that we are switching to
        break;
      }

      if (this.claimValidationById[claim.id] !== true) {
        this.setClaimValidation(claim, false); // mark false so it can be highlighted
        allValid = false;
      }
    }

    return allValid;
  }

  private setClaimValidation(claim: any, validation: boolean) {
    Vue.set(this.claimValidationById, claim.id, validation);
  }

  private updateCurrentClaim() {
    return this.updateClaim(this.claimsById[this.selectedClaimId!]);
  }

  private updateAllClaims(claimSource: any) {
    const {
      ['__typename']: _ignore,
      ticketDefinition,
      ...attendee
    } = claimSource.attendee;
    // do not copy Survey results (this may change)

    // when updating all claims, also update the purchaser
    this.order.purchaser = {
      ...(this.order.purchaser || {}),
      firstName: attendee.firstName,
      lastName: attendee.lastName,
      email: attendee.email,
    };

    return this.api!.updateAllClaims(this.order.id, {
      attendee,
    }).then((result) => {
      // update local state
      this.refreshCachedOrder(result.data.order.updateAllClaims.order);
      result.data.order.updateAllClaims.order.claims.forEach((updatedClaim) => {
        this.refreshCachedClaim(updatedClaim);
      });

      return result.data.order.updateAllClaims.order.claims;
    });
  }

  private updateClaim(claim: any) {
    const {
      ['__typename']: _ignore,
      ticketDefinition,
      ...attendee
    } = claim.attendee;
    const surveyResponses = claim.surveyResponses
      // backend (graphene) can't handle null in JSONString, replace null with empty string
      // and trim off __typename for the rest
      .map((surveyResponse) => {
        const { ['__typename']: _ignore, ...trimmedResponse } = surveyResponse;
        if (trimmedResponse.response === 'null') {
          trimmedResponse.response = JSON.stringify('');
        }
        return trimmedResponse;
      });

    return this.api!.updateClaim(this.order.id, claim.id, {
      attendee,
      surveyResponses,
    }).then((result) => {
      // update local state
      this.refreshCachedClaim(result.data.order.updateClaim.claim);
      return result;
    });
  }

  private async submitOrder() {
    const isFormValid = await this.$validator.validateAll();
    // If one validation has failed, we stop here
    if (!isFormValid) {
      return;
    }

    // When payment is required, validate the card fields up-front so an empty
    // or invalid card surfaces an inline error instead of a failed purchase.
    if (this.orderTotal > 0 && !(await this.validatePaymentFields())) {
      return;
    }

    if (this.api === null) {
      return;
    }

    this.busy = true;
    const mutation = {
      purchaser: this.order.purchaser || {},
      donationAmount: this.order.donationAmount,
    };
    this.api
      .updateOrder(this.order.id, mutation)
      .then((res) => {
        const errors = this.handleSuccess(
          res,
          '',
          'data.order.update.errors',
        );
        if (!errors) {
          if (this.orderTotal > 0) {
            this.createMethodAndComplete();
          } else {
            this.completeOrder({});
          }
        } else {
          this.$msgbox(JSON.stringify(errors), 'Error');
          this.busy = false;
        }
      })
      .catch(this.handleFailure);
  }

  // Gate submission on a fresh validity snapshot of the card fields. Returns
  // false when the card number, expiry, or CVV are empty or invalid.
  //
  // We only trust validation.isValid — validation.errors is card-first and
  // flags an autofilled-but-unexamined field as "required" even when it is
  // filled, so surfacing it would mislabel the problem (e.g. "Card number is
  // required" when only the CVV is missing). Instead we defer to the inline
  // message the live 'validation' event already set via describeInvalidField,
  // and only fall back to a generic message when none has been shown.
  private async validatePaymentFields(): Promise<boolean> {
    if (!this.tokenizer) {
      this.tokenizerError = 'Payment form is not ready. Please try again.';
      return false;
    }

    const validation = await this.tokenizer.validate();
    if (validation.isValid) {
      this.tokenizerError = '';
      return true;
    }

    if (!this.tokenizerError) {
      this.tokenizerError = 'Please check your payment information.';
    }
    return false;
  }

  private getBillingData() {
    return {
      contact: {
        salutation: ApiUtils.toStringPath(this.order, 'purchaser.salutation'),
        firstName: ApiUtils.toStringPath(this.order, 'purchaser.firstName'),
        lastName: ApiUtils.toStringPath(this.order, 'purchaser.lastName'),
        company: '',
        email: ApiUtils.toStringPath(this.order, 'purchaser.email'),
        primaryPhone: ApiUtils.toStringPath(this.order, 'purchaser.phone'),
      },
      address: {
        address1: ApiUtils.toStringPath(this.order, 'purchaser.address.street'),
        address2: ApiUtils.toStringPath(this.order, 'purchaser.address.street2'),
        city: ApiUtils.toStringPath(this.order, 'purchaser.address.city'),
        state: ApiUtils.toStringPath(this.order, 'purchaser.address.state'),
        zip: ApiUtils.toStringPath(this.order, 'purchaser.address.zip'),
        country: ApiUtils.toStringPath(this.order, 'purchaser.address.country'),
      },
    };
  }

  private async resolvePaymentToken(): Promise<string> {
    if (!this.tokenizer) {
      throw new Error('Payment form is not ready. Please try again.');
    }

    const validation = await this.tokenizer.validate();
    if (!validation.isValid) {
      const errorMessages = validation.errors.map((e: any) => e.message).join(', ');
      throw new Error(errorMessages || 'Please check your payment information.');
    }

    const paymentData = buildPaymentData(this.order.purchaser);
    const result: tokenize.PaymentToken = await this.tokenizer.tokenize(paymentData);
    return result.token;
  }

  private async createMethodAndComplete() {
    if (this.$sdkClient === null) { return; }

    try {
      const paymentMethodToken = await this.resolvePaymentToken();
      const recaptchaToken = await this.$captcha.resolveToken();

      const paymentMethodRequest: CreatePaymentMethodRequest = {
        paymentGatewayId: this.event.organization.gateway.id,
        paymentMethodToken,
        recaptchaToken,
        recaptchaType: 'invisible',
        paymentMethodType: 'credit_card',
        ...this.getBillingData(),
      };

      const newMethod: any = await this.$sdkClient.createPaymentMethod(paymentMethodRequest);
      if (newMethod && ApiUtils.hasValue(newMethod.paymentMethodId)) {
        this.completeOrder({ paymentMethodId: newMethod.paymentMethodId });
      } else {
        this.busy = false;
      }
    } catch (err) {
      this.handleFailure(err);
    }
  }

  private completeOrder(backendData) {
    if (this.api === null) {
      return;
    }
    this.busy = true;
    let hasErrors = false;
    let errors: string[] = [];
    this.api
      .completeOrder(this.order.id, backendData)
      .then((res2) => {
        errors = this.handleSuccessIgnoreError(
          res2,
          'data.order.complete.errors',
        );
        this.preview = this.handleSuccess(
          res2,
          'data.order.complete.preview',
          'data.order.complete.preview',
        );
      })
      .catch((err) => {
        hasErrors = true;
        const message = err instanceof Error ? err.message : String(err);
        if (message) {
          errors = [message];
        }
      })
      .finally(() => {
        this.busy = false;
        if (ApiUtils.hasValue(errors) || hasErrors) {
          this.purchaseErrors = errors;
          this.$bvModal.show('payment-failed-modal');
        } else {
          this.$bvModal.show('payment-successful-modal');
        }
      });
  }

  private closeModal() {
    if (this.orderExpiresWatch !== null) {
      window.clearInterval(this.orderExpiresWatch!);
      this.orderExpiresWatch = null;
    }

    this.$emit('close');
    this.releaseAllClaims();
    this.resetModal();
  }

  private refreshPage() {
    window.history.go();
  }

  private showTerms() {
    const terms =
      '<div class="terms-conditions">' + this.event.terms + '</div>';
    const h = this.$createElement;
    this.$msgbox({
      title: 'Terms & Conditions',
      message: h(Vue.compile(terms)),
      confirmButtonText: 'OK',
    });
  }

  private scrollToTop() {
    document
      .getElementById('ticket-checkout')!
      .children[0].scrollIntoView(true);
  }
}
